module.exports = __webpack_public_path__ + "static/media/logo.0a862d97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/bokadirekt/logo.png
// module id = 50
// module chunks = 0